const negocioData = {
  telefonoWhatsapp: '+526671743222',
  email: 'cleanzone.ventas1@gmail.com',
};

export default negocioData;
